import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { updateUriRef } from '../../../actions/filterActions';
import { getFilterValues, hasFilterApplied } from '../sbSharedRefineMenuHelpers';

import styles from './SbSharedRefineMenuSaleInput.scss';

import get from 'lodash.get';

// components
import { SbSharedRefineMenuInputCheckbox } from '../../SbSharedRefineMenu/SbSharedRefineMenuInput/SbSharedRefineMenuInputCheckbox';

// Constants
import { SALE } from '../../SbSharedRefineMenu/sbSharedRefineMenuConstants';

const messages = defineMessages({
    title: {
        id: 'sb.SbMobileRefineMenuFilterSale.title',
        defaultMessage: 'On sale',
    },
});

const SbSharedRefineMenuSaleInputComponent = ({ itemSearch, onChange, intl }) => {
    const filters = get(itemSearch, 'filters') || [];
    const saleFilterValues = getFilterValues(filters, SALE);
    const appliedFilters = get(itemSearch, 'appliedFilters') || [];
    const isSaleFilterApplied = hasFilterApplied(appliedFilters, [SALE]);

    return saleFilterValues.map(filter => {
        const count = get(filter, 'count');
        return (
            <SbSharedRefineMenuInputCheckbox
                key={filter.urlLabel}
                value={filter.urlLabel}
                linkReference={filter.linkReference}
                linkable={filter.linkable}
                checked={isSaleFilterApplied}
                onChange={checked => {
                    onChange(SALE, filter, !checked);
                }}
                text={intl.formatMessage(messages.title)}
                className={styles.wrapper}
                count={count}
            />
        );
    });
};

SbSharedRefineMenuSaleInputComponent.propTypes = {
    intl: intlShape,
    itemSearch: PropTypes.shape({
        appliedFilters: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                values: PropTypes.arrayOf(
                    PropTypes.shape({
                        linkReference: PropTypes.string.isRequired,
                    })
                ).isRequired,
            })
        ).isRequired,
        filters: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                values: PropTypes.arrayOf(
                    PropTypes.shape({
                        displayName: PropTypes.string.isRequired,
                        urlLabel: PropTypes.string.isRequired,
                        linkReference: PropTypes.string.isRequired,
                        linkable: PropTypes.bool.isRequired,
                        count: PropTypes.number,
                    })
                ).isRequired,
            })
        ).isRequired,
    }),
    onChange: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
    return {
        onChange(filtnerName, filterValue, isDeselected) {
            dispatch(updateUriRef({ filtnerName, filterValue, isDeselected }));
        },
    };
}

export const SbSharedRefineMenuSaleInput = createFragmentContainer(
    injectIntl(
        connect(
            null,
            mapDispatchToProps
        )(SbSharedRefineMenuSaleInputComponent)
    ),
    {
        itemSearch: graphql`
            fragment SbSharedRefineMenuSaleInput_itemSearch on ItemSearchQueryConnection {
                appliedFilters {
                    name
                    values {
                        linkReference
                    }
                }
                filters {
                    name
                    values {
                        linkReference
                        linkable
                        displayName
                        urlLabel
                        count
                    }
                }
            }
        `,
    }
);
